import React, {useState, useEffect, useRef, useContext} from 'react';
import {useHistory} from 'react-router-dom';
import EntityListItem from './EntityListItem';
import {filterByValue} from 'Helpers/filterByValue';
import SearchInput from 'components/SearchInput';
import {EntityContext} from 'contexts/EntityContext';
import {VariableSizeList as List} from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';
import './style.scss';
import {DropdownToggle} from 'reactstrap';
import Tooltip from 'components/Tooltip';

const EntitiesList = (props) => {
    let history = useHistory();

    const {activeEntity, setActiveEntity} = useContext(EntityContext);

    const {entitiesList, refreshEntities, changeCompanySelection, companyDropdownOpen, toggleEditMode, setIsDeleteModalOpen, entitiesLoading, scrollRef} = props;

    const [searchValue, setSearchValue] = useState('');
    const [visibleList, setVisibleList] = useState([]);

    useEffect(() => {
        let filteredArr = searchValue.length ? filterByValue(entitiesList, 'title', searchValue) : [...entitiesList];
        setVisibleList(filteredArr);
        scrollRef.current && scrollRef.current.resetAfterIndex(0);
    }, [searchValue, entitiesList]);

    const resetSearch = () => setSearchValue('');

    const Row = ({index, style}) => (
        <div key={index} style={{...style, margin: '0 auto'}}>
            <EntityListItem
                // key={'sidebar'+visibleList[index].id}
                entity={visibleList[index]}
                isActive={activeEntity && activeEntity.id === visibleList[index].id}
                entitiesLoading={entitiesLoading}
                changeCompanySelection={changeCompanySelection}
                companyDropdownOpen={companyDropdownOpen}
                toggleEditMode={toggleEditMode}
                setIsDeleteModalOpen={setIsDeleteModalOpen}
                index={index}
                setActiveEntity={setActiveEntity}
                activeEntity={activeEntity}
                refreshEntities={refreshEntities}
            />
        </div>
    );

    const getItemHeight = (index) => {
        // if(visibleList[index].title && visibleList[index].domain && (visibleList[index].title.length > 25 || visibleList[index].domain.length > 25)) {
        //     return 83;
        // } else {
        //     return 62
        // }

        // let el = document.getElementById('entity-' + visibleList[index].id)
        // let height = el ? el.offsetHeight() : 62;
        // return height
        return 62
    }

    // const [setImg, hasError, retry, imgRef] = useImageFallback();

    return (
        <>
            <div className="home-page-left-column__header">
                <div className="home-page-left-column__title">
                    Entities
                </div>
                <Tooltip placement="bottom" wide tooltip={`Create Entity`}>
                <div
                    className="home-page-left-column__add-btn"
                    onClick={() => history.push('/add-entity')}
                >
                    <i className="fas fa-plus"/>
                </div>
                </Tooltip>
            </div>
            <div className="home-page-left-column__search">
                <div style={{padding: '10px 15px'}}>
                    <SearchInput
                        value={searchValue}
                        onChange={setSearchValue}
                        placeholder="Search entities"
                        onClear={resetSearch}
                    />
                </div>
            </div>
            <div className="home-page-left-column__body new-scroll-style">
                <AutoSizer>
                    {({height, width}) => (
                        <List
                            width={width}
                            height={height}
                            itemCount={visibleList.length}
                            itemSize={(i) => getItemHeight(i)}
                            estimatedItemSize={62}
                            ref={scrollRef}
                        >
                            {Row}
                        </List>
                    )}
                </AutoSizer>
                {/*{visibleList && visibleList.map((item, index) =>*/}
                {/*    <EntityListItem*/}
                {/*        key={'sidebar'+item.id}*/}
                {/*        entity={item}*/}
                {/*        isActive={activeEntity && activeEntity.id === item.id}*/}
                {/*        entitiesLoading={entitiesLoading}*/}
                {/*        changeCompanySelection={changeCompanySelection}*/}
                {/*        companyDropdownOpen={companyDropdownOpen}*/}
                {/*        toggleEditMode={toggleEditMode}*/}
                {/*        setIsDeleteModalOpen={setIsDeleteModalOpen}*/}
                {/*        index={index}*/}
                {/*        setActiveEntity={setActiveEntity}*/}
                {/*        activeEntity={activeEntity}*/}
                {/*        refreshEntities={refreshEntities}*/}
                {/*    />*/}
                {/*)}*/}
            </div>
        </>
    );
};

export default EntitiesList;